module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Chaise_Ocean.0f22d1a6.png";